import { Button, Card, Col, Form } from "react-bootstrap";
import LoadingButton from "../../../components/loading/LoadingButton";
import DateFilter from "../../../components/filter/DateFilter";
import useFilterParams from "../../../hooks/useFilterParams";

export default function DigikalaCoworkerCreditFilters({ refetch, isFetching }) {
  const { getParam, setParam } = useFilterParams();

  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        setParam("page", 1);
        refetch();
      }}
    >
      <Card className="mt-4 mb-4 d-flex flex-wrap flex-row row-gap-3">
        <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
          <Form.Label>تعداد نمایش:</Form.Label>
          <Form.Select
            defaultValue={getParam("items")}
            onChange={e => setParam("items", e.target.value)}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </Col>

        <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
          <Form.Label>شماره سفارش:</Form.Label>
          <Form.Control
            type="number"
            onChange={e => setParam("numberParcel", e.target.value)}
          />
        </Col>

        <div className="d-flex flex-wrap w-100">
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
            <DateFilter
              value={getParam("startDate")}
              label="از تاریخ:"
              set={value => setParam("startDate", value)}
            />
          </Col>
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
            <DateFilter
              value={getParam("endDate")}
              label="تا تاریخ:"
              set={value => setParam("endDate", value)}
            />
          </Col>
        </div>

        <div className="w-100 px-2">
          {isFetching && (
            <LoadingButton className="btn-primary" title="در حال دریافت" />
          )}
          {!isFetching && <Button type="submit">فیلتر</Button>}
        </div>
      </Card>
    </form>
  );
}
